import React, { useEffect, useState } from "react";
import api from "../common/apiClient";
import SummaryAPI from "../common/SummaryApi";
import BannerForm from "../panelComponents/BannerForm";
import BannerTable from "../panelComponents/BannerTable";

const AllBanners = () => {
  const [banners, setBanners] = useState([]);
  // const [activeCategory, setActiveCategory] = useState("women");

  const fetchBanners = async () => {
    const res = await api({
      method: SummaryAPI.getAllBanners.method,
      url: SummaryAPI.getAllBanners.url
    });
    setBanners(res.data.data || []);
  };

  useEffect(() => {
    fetchBanners();
  }, []);

  return (
    <div className=" space-y-6">
      <h1 className="text-2xl font-bold mb-4">Banner Management</h1>

      <BannerForm onSuccess={fetchBanners} />

      <BannerTable banners={banners} onRefresh={fetchBanners} />
    </div>
  );
};

export default AllBanners;
